import React, { useState } from 'react'
import '../css/navbar.css'
import Winners from '../winners';
import {service} from '../../utils/constant';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    const onLogout = () => {
        window.location.href = "/unsub"
    }

    const token = sessionStorage.getItem('token');

    return (
      <>
        <nav className="navigation">
          <a href="/" className="brand-name">
            <img src="/images/uv_games_logo.png" alt="UV Games Logo" className="mainLogo"/>
          </a>
          <div>
            {/* {!!token && ( */}
            <div className = "mobile-icons">
            {(!!token && service ==="mtnet") && <li><button className="mobile-wallet-button winners_button" onClick={() => navigate('/unsub/wallet')}> <i className="fa-solid fa-wallet"></i></button></li>}
              <button
                className="mobile-android-button winners_button"
                onClick={() => navigate('/allGames/Android')}
              >
                <i className="fa fa-android"></i>
              </button>
              <button
                className="mobile-winner-button winners_button"
                onClick={openModal}
              >
                <i className="fa-solid fa-trophy"></i>
              </button>
            </div>
           
            {/* )} */}
            <button
              className="hamburger"
              onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }}
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>

          <div
            className={
              isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
            }
          >
            <ul>
              <li>
                <a href="/allGames/Sports">Sports</a>
              </li>
              <li>
                <a href="/allGames/Funny">Funny</a>
              </li>
              <li>
                <a href="/allGames/Action">Action</a>
              </li>
              <li>
                <a href="/allGames/Adventure">Adventure</a>
              </li>
              <li>
                <a href="/allGames/Racing">Racing</a>
              </li>
              <li>
                <a href="/allGames/Kids">Kids</a>
              </li>
              <li>
                <a href="/allGames/Puzzle">Puzzle</a>
              </li>
              <li className = "mobile-category">
                <a href="/allGames/Android">Android Games</a>
              </li>
              {/* <li>   <a href="/allGames/Sports">Arcade</a> </li> */}
              <>
               
                <li>
                    <button className="winners_button tabletdesktop-winner-button" onClick={() => navigate('/allGames/Android')}>
                      <i className="fa fa-android"></i> Android Games
                    </button>
                </li>
                {service ==="sl" ? <></> :
                  <li> <button className="winners_button tabletdesktop-winner-button"  onClick={openModal}>
                      <i className="fa-solid fa-trophy"></i>{service==="mtnet"?"Leader Board": "Winners"}
                    </button>
                  </li>
                }

                {!!token && (
                  <>
                  {service ==="mtnet" && <li><button className="winners_button tabletdesktop-winner-button" onClick={() => navigate('/unsub/wallet')}> <i className="fa-solid fa-wallet"></i></button></li>}
                  <li>
                    <button className="logout_button tabletdesktop-logout-button" onClick={onLogout}>                      
                      {service==="mtnet"?<i className="fas fa-house"></i>:
                      <><i className="fas fa-sign-out"></i> Unsub</>}
                    </button>
                  </li>
                  </>
                )}
              </>
            </ul>
          </div>
        </nav>
        {/* {!!token && <Winners isOpen={isOpen} closeModal={closeModal} />} */}
        <Winners isOpen={isOpen} closeModal={closeModal} />
      </>
    );
}

export default Navbar